var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalInfoBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 930,
    height: 650.239,
    viewBox: "0 0 930 650.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M493.8,412.674,57.62,440.228V80.08L493.8,104.139Z",
    transform: "translate(-57.62 -80.08)",
    fill: "#e5e5e5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "personal_info_bg",
    transform: "translate(-1135 -326.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "personal_info",
    transform: "translate(1135 326.869)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1175",
    "data-name": "Rectangle 1175",
    width: 930,
    height: 650,
    transform: "translate(0 -0.103)",
    fill: "#f4f5f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Information_tab-bro",
    "data-name": "Information tab-bro",
    transform: "translate(9.74 0.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-46",
    transform: "translate(66.489 44.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M738.239,287.95c-1.557-9.285-3.411-18.4-5.435-27.284C716.3,188.385,678.154,111.694,603.4,82.5c-86-33.568-208.072-24.269-285.009,41.293-59.182,50.4-179.1,80.816-246.073,157.222C2.9,360.232-11.6,508.679,78.545,568.6c64.119,42.613,143.392,9,214.8-5.085,40.664-8.01,75.862-3.48,115.95,0,69.664,6,141.819,10.5,212.075-4.5,34.7-7.5,65.552-21.089,85.113-52.077C747.568,441.768,750.4,359.722,738.239,287.95Z",
    transform: "translate(-15.556 -63.528)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M711.559,287.95c-1.5-9.285-3.285-18.4-5.235-27.284C690.425,188.385,653.691,111.694,581.7,82.5,498.869,48.937,381.3,58.236,307.208,123.8c-57,50.4-172.492,80.816-236.989,157.222C3.368,360.232-10.6,508.679,76.219,568.6c61.752,42.613,138.1,9,206.87-5.085,39.163-8.01,73.061-3.48,111.67,0,67.092,6,136.583,10.5,204.245-4.5,33.418-7.5,63.132-21.089,81.971-52.077C720.543,441.768,723.273,359.722,711.559,287.95Z",
    transform: "translate(57.625 -63.528)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M55.5,323h81a9,9,0,0,1,9,9h0a9,9,0,0,1-9,9H45a9,9,0,0,1-9-9h0a9,9,0,0,1,9-9h2.25",
    transform: "translate(-10.501 110.254)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M118.5,342.85h18a9,9,0,0,1,9,9h0a9,9,0,0,1-9,9H45a9,9,0,0,1-9-9h0a9,9,0,0,1,9-9h65.247",
    transform: "translate(-10.501 120.178)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M136.5,380.709H45a9,9,0,0,1-9-9h0a9,9,0,0,1,9-9h91.5a9,9,0,0,1,9,9h0a9,9,0,0,1-9,9Z",
    transform: "translate(-10.501 130.106)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M90.5,303h45.748V426.744H75.5",
    transform: "translate(9.246 100.256)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M49,426.744H29.5V303H103",
    transform: "translate(-13.751 100.256)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    x1: 31.498,
    transform: "translate(42.748 527)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    x2: 115.494,
    transform: "translate(22.499 421.255)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M131.5,54.15h81a9,9,0,0,1,9,9h0a9,9,0,0,1-9,9H121a9,9,0,0,1-9-9h0a9,9,0,0,1,9-9h2.25",
    transform: "translate(27.493 -24.151)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M194.5,74h18a9,9,0,0,1,9,9h0a9,9,0,0,1-9,9H121a9,9,0,0,1-9-9h0a9,9,0,0,1,9-9h65.247",
    transform: "translate(27.493 -14.228)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1169",
    "data-name": "Rectangle 1169",
    width: 109.495,
    height: 17.999,
    rx: 6,
    transform: "translate(139.493 89.546)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M166.5,34.15h45.748V157.894H151.5",
    transform: "translate(47.24 -34.15)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M125,157.894H105.5V34.15H179",
    transform: "translate(24.244 -34.15)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    x1: 31.498,
    transform: "translate(156.742 123.744)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    x2: 115.494,
    transform: "translate(136.493 17.999)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M393.018,80.319H345.725A3.615,3.615,0,0,1,342.11,76.7V62.965a3.615,3.615,0,0,1,3.615-3.615H409.1a3.615,3.615,0,0,1,3.615,3.615V68.35",
    transform: "translate(142.532 -21.552)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M375.75,99.593V70.21a4.725,4.725,0,0,1,4.71-4.71h62.757a4.725,4.725,0,0,1,4.71,4.71V105.4",
    transform: "translate(159.349 -18.477)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M447.927,120.664v36.658a4.725,4.725,0,0,1-4.71,4.71H380.46a4.725,4.725,0,0,1-4.71-4.71V92.93",
    transform: "translate(159.349 -4.764)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    x2: 63.222,
    transform: "translate(539.554 64.197)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    x2: 33.013,
    transform: "translate(569.763 83.261)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    x2: 25.049,
    transform: "translate(539.554 83.261)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    x2: 63.222,
    transform: "translate(539.554 102.325)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    x2: 11.324,
    transform: "translate(591.451 121.389)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    x2: 46.198,
    transform: "translate(539.554 121.389)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    x2: 63.222,
    transform: "translate(539.554 140.468)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    x2: 34.453,
    transform: "translate(497.406 47.803)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M237.492,365.819H172.3a5,5,0,0,1-4.995-4.98V341.895A5,5,0,0,1,172.3,336.9h87.341a5,5,0,0,1,4.995,4.995v7.425",
    transform: "translate(55.144 117.203)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M213.69,392.393v-40.5a6.5,6.5,0,0,1,6.495-6.495h86.5a6.5,6.5,0,0,1,6.495,6.495v48.523",
    transform: "translate(78.331 121.452)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M313.16,421.433v50.533a6.5,6.5,0,0,1-6.495,6.495h-86.5a6.5,6.5,0,0,1-6.495-6.495V383.2",
    transform: "translate(78.321 140.35)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    x2: 87.161,
    transform: "translate(298.156 490.506)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_102",
    "data-name": "Line 102",
    x2: 45.523,
    transform: "translate(339.794 516.785)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_103",
    "data-name": "Line 103",
    x2: 34.543,
    transform: "translate(298.156 516.785)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_104",
    "data-name": "Line 104",
    x2: 87.161,
    transform: "translate(298.156 543.079)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    x2: 15.614,
    transform: "translate(369.702 569.358)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    x2: 63.687,
    transform: "translate(298.156 569.358)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    x2: 87.161,
    transform: "translate(298.156 595.636)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x2: 47.488,
    transform: "translate(240.063 467.917)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M296.168,424.183a14.385,14.385,0,0,1-10.02-4.05l-9.285-9.21a3.36,3.36,0,0,1,4.665-4.83l1.83,1.71-9.345-19.214a4.05,4.05,0,0,1-.12-3.1,3.975,3.975,0,0,1,7.3-.3l3.48,6.855a4.11,4.11,0,0,1,2.49-1.5,5.4,5.4,0,0,1,3.69,1.065,4.02,4.02,0,0,1,2.61-1.5,4.844,4.844,0,0,1,3.12.75,2.625,2.625,0,0,1,2.73-1.65,3.765,3.765,0,0,1,3,1.98l6.6,12.134a14.4,14.4,0,0,1-12.824,20.924Zm-16.934-17.5h-.24a1.86,1.86,0,0,0-1.08,3.165l9.285,9.195a12.884,12.884,0,0,0,20.459-15.1l-6.57-12.1a2.265,2.265,0,0,0-1.8-1.2c-.615,0-1.275.105-1.5,1.5l-.225,1.365-1.02-.93a4.125,4.125,0,0,0-2.85-1.035,3,3,0,0,0-2.025,1.5l-.48.765-.675-.615a4.5,4.5,0,0,0-3.1-1.2,3.24,3.24,0,0,0-2.175,1.8l-.72,1.245-4.68-9.24a2.486,2.486,0,0,0-4.5,2.115l12.674,26.324-7.5-7.08a1.815,1.815,0,0,0-1.275-.465Z",
    transform: "translate(108.302 140.21)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M284.639,399.068a.765.765,0,0,1-.69-.465l-3.45-8.115a.765.765,0,0,1,.4-.99.75.75,0,0,1,.975.405l3.45,8.115a.75.75,0,0,1-.39.99.675.675,0,0,1-.3.06Z",
    transform: "translate(111.702 143.471)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M288.5,397.542a.75.75,0,0,1-.69-.45l-3-7.125a.75.75,0,0,1,.39-.99.78.78,0,0,1,.99.4l3,7.125a.735.735,0,0,1-.4.975.614.614,0,0,1-.285.06Z",
    transform: "translate(113.855 143.212)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M292.394,396.2a.72.72,0,0,1-.675-.435l-2.895-6.225a.735.735,0,0,1,.36-.99.75.75,0,0,1,1.005.36l2.895,6.225a.735.735,0,0,1-.69,1.065Z",
    transform: "translate(115.856 142.99)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1170",
    "data-name": "Rectangle 1170",
    width: 20.999,
    height: 20.999,
    transform: "translate(367.632 30.303) rotate(-45)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1171",
    "data-name": "Rectangle 1171",
    width: 20.999,
    height: 20.999,
    transform: "translate(625.768 193.783) rotate(-45)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1172",
    "data-name": "Rectangle 1172",
    width: 20.999,
    height: 20.999,
    transform: "translate(171.293 553.781) rotate(-45)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1173",
    "data-name": "Rectangle 1173",
    width: 11.459,
    height: 11.459,
    transform: "translate(346.781 50.767) rotate(-45)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1174",
    "data-name": "Rectangle 1174",
    width: 11.459,
    height: 11.459,
    transform: "translate(339.288 445.256) rotate(-45)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(265.487 505.251)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(457.478 439.254)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(623.97 76.271)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(0 94.795)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screens--inject-46",
    transform: "translate(234.194 36.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M188.974,88.394,175.849,66.21,55.06,58.26v401.2l442.509-29.144V106.453Z",
    transform: "translate(-55.06 -58.26)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M493.8,412.674,57.62,440.228V80.08L493.8,104.139Z",
    transform: "translate(-53.78 -47.352)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(3.84 32.728)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M352.535,407.885l-8.685.555V94.1l8.685.495Z",
    transform: "translate(85.474 -73.071)",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M352.535,342.039l-8.685.54V220.86l8.685-.15Z",
    transform: "translate(85.474 -9.775)",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M494.969,118.443,56.27,96.364V76.76l438.7,24.9Z",
    transform: "translate(-58.295 -81.74)",
    fill: "#09f",
    stroke: "#263238",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M493.8,412.674,57.62,440.228V80.08L493.8,104.139Z",
    transform: "translate(-53.78 -47.352)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M460.537,138.434l-68.052-2.58h-.075l-71.652-2.715-.075-.015-75.536-2.85-.09-.015-79.736-3.015h-.09L80.89,124.05v27.584h0V404.507l379.482-20.8V162.553h.165Z",
    transform: "translate(-42.147 -25.37)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M185.991,147.764l-85-2.34v-27.7l85,3.1Z",
    transform: "translate(-32.098 -28.534)",
    fill: "#09f",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M153.4,132.055l-35.608-1.11V125.77l35.608,1.17Z",
    transform: "translate(-23.7 -24.51)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M238.116,148.929l-80.4-2.2V119.8l80.4,2.925Z",
    transform: "translate(-3.737 -27.494)",
    fill: "#09f",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M287.531,150.039l-76.151-2.085v-26.2l76.151,2.775Z",
    transform: "translate(23.089 -26.52)",
    fill: "#09f",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M415.03,151.089V126.235l-72.236-2.625v25.5l-241.8-6.63V396.357l382.587-21.314V152.979Z",
    transform: "translate(-32.098 -25.59)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M379.027,152.1l-68.607-1.89V125.36l68.607,2.5Z",
    transform: "translate(72.602 -24.715)",
    fill: "#09f",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M413.546,328.052,219.74,337.127V170.83l193.806,2.145Z",
    transform: "translate(27.268 -1.983)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M303.173,172.17l-48.133-.51v19.859l48.133.18Z",
    transform: "translate(44.916 -1.568)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    y1: 0.075,
    x2: 14.789,
    transform: "translate(411.37 213.26)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    "data-name": "Line 110",
    y1: 0.36,
    x2: 78.926,
    transform: "translate(323.444 213.38)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    y1: 0.255,
    x2: 55.512,
    transform: "translate(259.307 213.785)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    y1: 0.525,
    x2: 63.147,
    transform: "translate(363.012 223.459)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    y1: 0.21,
    x2: 25.499,
    transform: "translate(327.254 224.074)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    y1: 0.48,
    x2: 56.472,
    transform: "translate(259.307 224.389)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_115",
    "data-name": "Line 115",
    y1: 1.59,
    x2: 129.729,
    transform: "translate(296.431 233.644)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_116",
    "data-name": "Line 116",
    y1: 0.3,
    x2: 24.404,
    transform: "translate(259.307 235.384)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    "data-name": "Line 117",
    y1: 0.51,
    x2: 31.019,
    transform: "translate(395.141 243.828)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_118",
    "data-name": "Line 118",
    y1: 0.81,
    x2: 50.293,
    transform: "translate(333.914 244.503)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_119",
    "data-name": "Line 119",
    y1: 1.035,
    x2: 64.137,
    transform: "translate(259.307 245.478)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_120",
    "data-name": "Line 120",
    y1: 2.19,
    x2: 110.38,
    transform: "translate(315.78 254.028)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_121",
    "data-name": "Line 121",
    y1: 0.9,
    x2: 45.853,
    transform: "translate(259.307 256.428)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_122",
    "data-name": "Line 122",
    y1: 0.345,
    x2: 14.789,
    transform: "translate(411.37 263.777)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_123",
    "data-name": "Line 123",
    y1: 1.845,
    x2: 78.926,
    transform: "translate(323.444 264.332)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_124",
    "data-name": "Line 124",
    y1: 1.29,
    x2: 55.512,
    transform: "translate(259.307 266.387)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_125",
    "data-name": "Line 125",
    y1: 1.725,
    x2: 63.147,
    transform: "translate(363.012 273.962)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_126",
    "data-name": "Line 126",
    y1: 0.69,
    x2: 25.499,
    transform: "translate(327.254 275.957)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_127",
    "data-name": "Line 127",
    y1: 1.545,
    x2: 56.472,
    transform: "translate(259.307 276.962)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_128",
    "data-name": "Line 128",
    y1: 4.02,
    x2: 129.729,
    transform: "translate(296.431 284.161)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    "data-name": "Line 129",
    y1: 0.75,
    x2: 24.404,
    transform: "translate(259.307 288.571)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    "data-name": "Line 130",
    y1: 1.08,
    x2: 31.019,
    transform: "translate(395.141 294.346)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    y1: 1.755,
    x2: 50.293,
    transform: "translate(333.914 295.801)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    "data-name": "Line 132",
    y1: 2.235,
    x2: 64.137,
    transform: "translate(259.307 297.916)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_133",
    "data-name": "Line 133",
    y1: 4.26,
    x2: 110.38,
    transform: "translate(315.78 304.53)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_134",
    "data-name": "Line 134",
    y1: 1.77,
    x2: 45.853,
    transform: "translate(259.307 309.195)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    "data-name": "Line 135",
    x2: 186.411,
    y2: 0.66,
    transform: "translate(252.738 190.326)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_136",
    "data-name": "Line 136",
    y2: 19.859,
    transform: "translate(299.956 170.092)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_137",
    "data-name": "Line 137",
    y2: 19.514,
    transform: "translate(348.088 170.617)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_138",
    "data-name": "Line 138",
    y2: 19.199,
    transform: "translate(394.616 171.112)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M292.158,181.385l-30.749-.21V176.36l30.749.255Z",
    transform: "translate(48.1 0.781)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M259.238,181.195l-31.858-.21v-4.9l31.858.27Z",
    transform: "translate(31.088 0.641)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M323.324,181.565l-29.714-.195v-4.74l29.714.255Z",
    transform: "translate(64.198 0.916)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M352.529,181.74l-28.739-.195V176.88l28.739.24Z",
    transform: "translate(79.286 1.041)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M259.738,347.98,111.89,354.9V150.41l147.848,3.03Z",
    transform: "translate(-26.649 -12.192)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M259.738,209.914,223.02,186.26l-33.313,73.766L156.723,234,111.89,336.973l147.848-6.915Z",
    transform: "translate(-26.649 5.731)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M164.078,186.99a22.5,22.5,0,0,0-22.23-22.5,22.2,22.2,0,0,0-22.5,22.229,22.5,22.5,0,0,0,22.5,22.5,22.229,22.229,0,0,0,22.229-22.229Z",
    transform: "translate(-22.92 -5.153)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M206.868,133.685l-33.688-1.05V127.58l33.688,1.11Z",
    transform: "translate(3.991 -23.605)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M257.848,135.22l-31.918-.99v-4.92l31.918,1.05Z",
    transform: "translate(30.363 -22.74)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M307.084,136.7l-30.254-.945v-4.77l30.254.99Z",
    transform: "translate(55.809 -21.9)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M352.954,138.09l-28.724-.9v-4.65l28.724.945Z",
    transform: "translate(79.506 -21.125)",
    fill: "#7a7a7a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-46",
    transform: "translate(623.757 146.417)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    cx: 87.371,
    cy: 12.674,
    rx: 87.371,
    ry: 12.674,
    transform: "translate(55.396 477.328)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 87.371,
    cy: 12.674,
    rx: 87.371,
    ry: 12.674,
    transform: "translate(55.396 477.328)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M369.02,141.82s-4.815,17.894-3.795,19.6,3.45,1.035,2.07,4.5-4.5,9.975-3.78,12.719,4.5,4.815,4.5,4.815,1.725,12.389,3.435,14.789,11.009,1.035,11.009,1.035l.69,9.3,27.524-1.725-1.035-16.5-1.38-51Z",
    transform: "translate(-270.651 -127.969)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M401.907,131.907c-1.71.255-14.8,0-25.124,1.71s-13.409,2.415-13.064,6.885-.69,6.195,3.09,7.9a15.391,15.391,0,0,0,5.16,1.725s-1.035,4.815-1.38,8.265,5.85,7.215,5.85,7.215-.345,5.16.345,6.885,2.415,2.07,3.45.69,1.71-7.92,2.745-5.16,5.16,23.384,7.92,25.8,15.134,1.035,18.569.345,9.975-15.134,13.079-23.744,1.71-23.729-2.76-30.614S406.376,131.217,401.907,131.907Z",
    transform: "translate(-270.509 -131.766)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M374.772,156.451a87.661,87.661,0,0,1,.84,9.66c0,3.78-2.52,5.88-.84,7.5s3,.84,4.2-2.1a24.809,24.809,0,0,0,1.68-10.919C380.232,157.711,379.812,151.411,374.772,156.451Z",
    transform: "translate(-265.259 -120.371)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M374.69,186.089l-7.5,13.754s18.914-5.5,29.234-5.5a141.124,141.124,0,0,1,21.674,2.07l-4.815-13.424S387.079,180.24,374.69,186.089Z",
    transform: "translate(-268.761 -106.482)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M426.236,307.28s0,12-1.035,17.2-7.9,13.064-10.664,14.444-6.195,1.725-6.885,0-1.71-1.035-.675-9.975,4.755-26.144,4.755-26.144Z",
    transform: "translate(-249.091 -46.256)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M426.919,299.48,424.5,310.489a26.88,26.88,0,0,1-9,.345,6.84,6.84,0,0,1-5.5-4.815l1.035-9.63Z",
    transform: "translate(-247.359 -49.465)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M425.224,199.75s4.815,29.234,7.9,50.908,3.765,42.313,3.075,52.632-4.815,43.5-6.195,45.883-10.664,3.435-14.444,1.71S410,347.118,410,340.563s3.435-67.5,3.435-67.5Z",
    transform: "translate(-247.359 -97.778)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M382.485,451.585a8.415,8.415,0,0,0-3.9.99c-2.04,1.08-10.889,3.51-16.589,5.535-8.895,3.165-15.839,1.5-15.119,3.78s14.594,6.99,22.619,7.11,11.894-1.89,15.734-1.815,1.005,1.935,7.395,2.655,8.475.75,10.709-2.745,3.48-4.395,2.775-8.8v-.06a8.16,8.16,0,0,0-8.175-6.69Z",
    transform: "translate(-278.941 28.098)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M413.982,448.731a5.865,5.865,0,0,0-3.36.945c-1.74,1.1-9.375,3.4-14.264,5.4-7.65,3.1-13.754,1.035-13.049,3.555s8.91,6,15.9,6.345a57.584,57.584,0,0,0,11.339-.42c7.5-.42,2.745,2.25,5.46,3.36a18.252,18.252,0,0,0,5.88.84c7.98.42,9,1.05,10.785-2.625s2.88-4.6,2.115-9.39v-.1c-.7-4.26-3.87-7.38-7.335-7.5Z",
    transform: "translate(-260.73 26.693)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M356.14,288.352s1.38,48.163,1.38,64.332,4.125,89.231,9.63,115.719,8.595,64.332,8.595,68.457-1.38,5.16,1.38,7.92,13.064,7.9,16.859,6.18,5.85-8.25,5.85-8.25,0-35.773,1.02-59.172-.675-54-.675-54,13.409,61.932,17.189,74.306,6.885,34.858,7.575,39.328,3.72,4.62,7.5,4.62c4.62,0,10.335-.6,12.389-4.035s-2.4-39.568-2.4-54-11.354-104.035-10.32-125.994,7.5-60.192,5.5-71.547a126.631,126.631,0,0,1-2.07-20.414S364.735,263.573,356.14,288.352Z",
    transform: "translate(-274.285 -62.411)",
    fill: "#5e5e5e",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M379.973,194.814s-15.389,6.525-22.6,9.975a108.44,108.44,0,0,1-10.32,4.5s11.594,109.495,11.594,115.359-.345,6.195,1.725,7.92,12.734,2.5,31.663,2.16,42.643-4.23,44.368-4.23a8.88,8.88,0,0,0,6.87-4.125c2.07-3.09,13.109-119.844,13.5-121.209s-27.209-11.354-29.624-12S410.9,183.115,379.973,194.814Z",
    transform: "translate(-278.829 -103.162)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M417.5,239.63c-9.839,14.159-25.379,34.753-37.5,42.553",
    transform: "translate(-262.357 -77.841)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M412.99,230s-1.785,2.865-4.77,7.335",
    transform: "translate(-248.249 -82.656)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M400.664,262.63s-13.619,12.389-24.764,18.584",
    transform: "translate(-264.406 -66.343)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M415.079,470.112a44.8,44.8,0,0,0,12.779,9.36v-2.82c0-14.444-11.354-104.035-10.32-125.994.18-4,.555-8.55,1.02-13.364a17.537,17.537,0,0,0-1.365-2.8,244.607,244.607,0,0,1-15.134-27.164l17.864,17.084c.15-1.29.3-2.595.435-3.885-4.755-8.55-11.009-20.279-11.429-23.864L387.93,308s-2.745,81.671-2.4,108.5c0,0,2.025,9.375,4.725,21.539C396.749,452.773,408.344,463.137,415.079,470.112Z",
    transform: "translate(-259.607 -49.331)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M358.9,286a83.034,83.034,0,0,0,4.5,12.479,14.579,14.579,0,0,0,6.195,6.54",
    transform: "translate(-272.905 -54.66)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M373.75,444.62a82.286,82.286,0,0,1-.18,15.854",
    transform: "translate(-265.571 24.639)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M372.67,431.48c.315,4.5.6,8.61.855,11.894",
    transform: "translate(-266.021 18.07)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M366.73,312.2c.855,34.5,2.91,110.215,4.755,127.089,1.335,12.239,2.565,29.144,3.57,43.5",
    transform: "translate(-268.991 -41.562)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M365.941,286.35c-.345,1.035.81,21.584.81,21.584s.075,3.495.225,9.39",
    transform: "translate(-269.417 -54.485)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M326.215,233.374s1.335-2.325,3.315-6.3,1.665-9,1.665-11.594,3-3.645,3-6.63-4.3-2.64-6.615-.66-3,7.95-3,7.95-3.675-6.21-5.625-10.589c-1.77-3.945-4.2-10.74-7.5-11.729s-3.15,3.1-2.8,4.095a38.988,38.988,0,0,0,2.04,5.625c.765,1.5,2.31,6,2.31,6s-4.635-3.645-6.285-3.645a2.43,2.43,0,0,0-1.995,3.645s-3.975,1.65-3,4.3,1.335,3.645,1.335,3.645-1.005,1.32,0,4.635,5.295,9,6.945,11.594a14.385,14.385,0,0,0,3.645,3.975Z",
    transform: "translate(-301.567 -100.819)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M303.68,204.24a27,27,0,0,0,3.675,4.5",
    transform: "translate(-300.511 -95.534)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M302.58,209.54a15,15,0,0,0,2.25,3",
    transform: "translate(-301.061 -92.884)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M313.13,238.143l-5.85-12.734a14.819,14.819,0,0,1,9.99-6.195c7.215-1.38,8.25,0,8.25,0l3.78,13.079S316.925,233.329,313.13,238.143Z",
    transform: "translate(-298.711 -88.354)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M347.193,258.046s-10.664-18.224-13.424-24.764-6.525-8.265-12.719-7.575-11.7,7.23-11.7,12,22.019,52.288,23.054,55.047,8.595,3.435,13.754.345S352.008,273.195,347.193,258.046Z",
    transform: "translate(-297.677 -84.873)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M358.419,202.5s-14.189,41.833-16.589,48.358-13.5,36.268-16.5,42.118-.33,15.824,9,17.2,10.664-1.38,15.479-8.265S366.5,277.826,366.5,277.826,361.209,210.4,358.419,202.5Z",
    transform: "translate(-290.274 -96.404)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalInfoBg);
export default __webpack_public_path__ + "static/media/personal_info_bg.f48eb86c7881a69aec20d3fb8b850fad.svg";
export { ForwardRef as ReactComponent };